import { render, staticRenderFns } from "./connect-header.vue?vue&type=template&id=72b85b42&scoped=true&"
import script from "./connect-header.vue?vue&type=script&lang=js&"
export * from "./connect-header.vue?vue&type=script&lang=js&"
import style0 from "./connect-header.vue?vue&type=style&index=0&id=72b85b42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b85b42",
  null
  
)

export default component.exports